export default __webpack_public_path__ + "static/media/JobFour3.49420bf9.jpg";